import { Resources } from 'constants/resources';

import { AxiosError, AxiosResponse } from 'axios';
import { axios } from 'config/axios';
import { Identifier } from 'react-admin';
import { ErrorData } from 'types/embedded/error';
import { formatAxiosToHydraError } from 'utils/formatAxiosToHydraError';

export type CreateProviderWhiteIpAddressesBulkData = {
  provider?: Identifier;
  ips: string[];
  comment: string;
  mask: number;
};

export const createProviderWhiteIpAddressesBulk = async (
  data: CreateProviderWhiteIpAddressesBulkData,
): Promise<AxiosResponse> => {
  return axios
    .post(`${Resources.ProviderWhiteIpAddresses}/bulk/create`, data, {
      headers: { Accept: 'application/ld+json' },
    })
    .then((response: AxiosResponse) => response.data)
    .catch((error: AxiosError<ErrorData>) => Promise.reject(formatAxiosToHydraError(error)));
};
